/*
 * Back-in-stock "Notify me" form (snippets/jc-notify-me.liquid).
 * - With an HQ endpoint (app proxy /apps/jungcards/bis) the request goes there as JSON;
 *   HQ stores it and sends the "back in stock" mail later
 * - Else with a Klaviyo public API key: Klaviyo's client Back-in-Stock API
 * - Else the form posts normally to the Shopify contact form
 * - Swaps the form when the customer selects another variant.
 */
if (!customElements.get('jc-notify-me')) {
  const KLAVIYO_REVISION = '2024-10-15';

  class JcNotifyMe extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.renderedAt = Date.now();
      if (!this.form) return;
      if (this.dataset.endpoint) {
        this.form.addEventListener('submit', this.onSubmitHq.bind(this));
      } else if (this.dataset.companyId) {
        this.form.addEventListener('submit', this.onSubmit.bind(this));
      }
    }

    async onSubmitHq(event) {
      event.preventDefault();
      const email = this.form.querySelector('input[type="email"]');
      const consent = this.form.querySelector('[data-consent]');
      const button = this.form.querySelector('button[type="submit"]');
      const status = this.form.querySelector('[data-status]');
      const error = this.form.querySelector('[data-error]');
      if (!email.checkValidity()) {
        email.reportValidity();
        return;
      }
      if (consent && !consent.checked) {
        consent.reportValidity();
        return;
      }
      error.hidden = true;
      button.disabled = true;
      const d = this.dataset;
      const hp = this.form.querySelector('[data-hp]');
      try {
        const response = await fetch(d.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            email: email.value.trim(),
            variantId: String(d.variantId),
            productId: String(d.productId || ''),
            productHandle: d.productHandle || '',
            productTitle: d.productTitle || '',
            variantTitle: d.variantTitle || '',
            locale: ['de', 'en', 'fr'].includes(d.locale) ? d.locale : 'de',
            consent: consent ? consent.checked : true,
            hp: hp ? hp.value : '',
            t: Date.now() - this.renderedAt,
          }),
        });
        if (response.status === 429) {
          error.textContent = this.querySelector('template[data-error-rate]').content.textContent.trim();
          throw new Error('rate limited');
        }
        if (!response.ok) throw new Error(`HQ ${response.status}`);
        status.textContent = this.querySelector('template[data-success]').content.textContent.trim();
        this.form.querySelector('.jc-drop-alarm__row').hidden = true;
        if (consent) consent.closest('label').hidden = true;
      } catch (e) {
        console.error(e);
        error.hidden = false;
        button.disabled = false;
      }
    }

    async onSubmit(event) {
      event.preventDefault();
      const email = this.form.querySelector('input[type="email"]');
      const button = this.form.querySelector('button[type="submit"]');
      const status = this.form.querySelector('[data-status]');
      const error = this.form.querySelector('[data-error]');
      if (!email.checkValidity()) {
        email.reportValidity();
        return;
      }
      error.hidden = true;
      button.disabled = true;

      try {
        const response = await fetch(
          `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${encodeURIComponent(this.dataset.companyId)}`,
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/vnd.api+json', revision: KLAVIYO_REVISION },
            body: JSON.stringify({
              data: {
                type: 'back-in-stock-subscription',
                attributes: {
                  channels: ['EMAIL'],
                  profile: { data: { type: 'profile', attributes: { email: email.value.trim() } } },
                },
                relationships: {
                  variant: {
                    data: { type: 'catalog-variant', id: `$shopify:::$default:::${this.dataset.variantId}` },
                  },
                },
              },
            }),
          }
        );
        if (!response.ok) throw new Error(`Klaviyo ${response.status}`);
        status.textContent = this.querySelector('template[data-success]').content.textContent.trim();
        this.form.querySelector('.jc-drop-alarm__row').hidden = true;
      } catch (e) {
        console.error(e);
        error.hidden = false;
        button.disabled = false;
      }
    }
  }

  customElements.define('jc-notify-me', JcNotifyMe);

  // Dawn re-renders parts of the product section on variant change and passes the new HTML.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      if (!data || !data.html) return;
      const id = `JcNotify-${data.sectionId}`;
      const current = document.getElementById(id);
      const next = data.html.getElementById(id);
      if (current && next) current.innerHTML = next.innerHTML;
    });
  }
}
